import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTbNeg = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "24 20 32 32",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(4,0) scale(3)",
		strokeWidth: 2,
		children: [
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 4,
				fill: "none",
				stroke: "white",
				strokeWidth: 2.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M 7,7 L 17,17",
				stroke: "blue",
				fill: "none"
			}),
			/* @__PURE__ */ _jsx("circle", {
				cx: 12,
				cy: 12,
				r: 4,
				fill: "none",
				stroke: "blue"
			})
		]
	})
});
export default SvgTbNeg;
